import { css } from '@emotion/react';

export const styles = {
    wrapper: css({
        marginBottom: '30px',
    }),
    label: css({
        margin: '0',
    }),
    checkbox: css({
        marginRight: '10px',
    }),
};
